/* Diabetes quiz controller.
   Connects the separate quiz sections (Start page, Questions, Loading screen,
   Results, Footer) and shows one screen at a time.
   Every section loads this file, so it guards against running twice. */
(function () {
  if (window.DQQuiz) return;

  var state = { screen: 'intro', i: 0, answers: [], timer: null, delay: null, tier: null, score: 0 };
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- helpers ---------- */
  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function wrap(el) { return el.closest('.shopify-section') || el; }
  function screenEl(name) { return q('[data-dq-screen="' + name + '"]'); }
  function track(event, data) {
    window.dataLayer = window.dataLayer || [];
    var o = { event: event };
    for (var k in data) if (Object.prototype.hasOwnProperty.call(data, k)) o[k] = data[k];
    window.dataLayer.push(o);
  }
  function clearTimers() { clearInterval(state.timer); clearTimeout(state.delay); state.timer = null; state.delay = null; }

  /* ---------- screens ---------- */
  function show(name, opts) {
    opts = opts || {};
    if (!screenEl(name)) {
      // A section was removed from the page: skip ahead sensibly.
      if (name === 'intro') name = 'quiz';
      if (name === 'loading') { return showResult(); }
    }
    state.screen = name;
    qa('[data-dq-screen]').forEach(function (el) {
      var on = el.getAttribute('data-dq-screen') === name;
      el.hidden = !on;
      var w = wrap(el); if (w !== el) w.hidden = !on;
    });
    qa('[data-dq-footer]').forEach(function (el) {
      var on = name === 'intro';
      el.hidden = !on;
      var w = wrap(el); if (w !== el) w.hidden = !on;
    });
    if (!opts.keepScroll && !designMode) window.scrollTo(0, 0);
  }

  /* ---------- questions ---------- */
  function parseOptions(raw) {
    return String(raw || '').split(/\r?\n/).map(function (line) {
      var parts = line.split('|');
      var label = (parts[0] || '').trim();
      var pts = parts.length > 1 ? parseFloat(parts[parts.length - 1]) : 0;
      if (parts.length > 2) label = parts.slice(0, -1).join('|').trim();
      return { label: label, points: isNaN(pts) ? 0 : pts };
    }).filter(function (o) { return o.label; });
  }
  function questions() {
    var node = q('[data-dq-questions]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent).map(function (x) {
        return { block: x.block, id: String(x.id), q: x.q || '', hint: x.hint || '', opts: parseOptions(x.opts) };
      }).filter(function (x) { return x.q && x.opts.length; });
    } catch (e) { return []; }
  }

  function renderQuestion(focus) {
    var sec = screenEl('quiz'); if (!sec) return;
    var Q = questions(); if (!Q.length) return;
    if (state.i >= Q.length) state.i = Q.length - 1;
    var cur = Q[state.i];
    var prog = q('[data-dq-progress]', sec);
    prog.style.gridTemplateColumns = 'repeat(' + Q.length + ', minmax(0, 1fr))';
    prog.innerHTML = Q.map(function (_, k) { return '<div class="fc-seg' + (k <= state.i ? ' is-on' : '') + '"></div>'; }).join('');
    var count = q('[data-dq-count]', sec);
    count.textContent = (count.getAttribute('data-format') || '[n] / [total]').replace('[n]', state.i + 1).replace('[total]', Q.length);
    var h = q('[data-dq-q]', sec); h.textContent = cur.q;
    var hint = q('[data-dq-hint]', sec); hint.textContent = cur.hint; hint.hidden = !cur.hint;
    var box = q('[data-dq-opts]', sec);
    box.innerHTML = '';
    var picked = state.answers[state.i];
    cur.opts.forEach(function (o, k) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fc-opt' + (picked && picked.index === k ? ' is-picked' : '');
      b.setAttribute('data-dq-opt', k);
      b.innerHTML = '<span class="fc-opt-dot" aria-hidden="true"></span><span></span>';
      b.lastChild.textContent = o.label;
      box.appendChild(b);
    });
    if (focus && !designMode) h.focus({ preventScroll: true });
  }

  function pick(k, btn) {
    var Q = questions(); var cur = Q[state.i]; if (!cur) return;
    var o = cur.opts[k];
    state.answers[state.i] = { id: cur.id, index: k, label: o.label, points: o.points };
    qa('.fc-opt', btn.parentNode).forEach(function (b) { b.classList.remove('is-picked'); });
    btn.classList.add('is-picked');
    track('quiz_answer', { quiz_step: state.i + 1, question_id: cur.id, answer: o.label, points: o.points });
    var sec = screenEl('quiz');
    var wait = sec ? parseInt(sec.getAttribute('data-advance'), 10) : 180;
    clearTimeout(state.delay);
    state.delay = setTimeout(function () {
      if (state.i < Q.length - 1) { state.i++; renderQuestion(true); }
      else startLoading();
    }, isNaN(wait) ? 180 : wait);
  }

  function start() {
    clearTimers();
    state.i = 0; state.answers = [];
    show('quiz'); renderQuestion(true);
    track('quiz_start', {});
  }

  /* ---------- loading ---------- */
  function paintLoading(lp) {
    var sec = screenEl('loading'); if (!sec) return;
    var pct = q('[data-dq-pct]', sec); if (pct) pct.textContent = Math.round(lp) + '%';
    var ring = q('[data-dq-ring]', sec); if (ring) ring.setAttribute('stroke-dashoffset', (351.9 * (1 - lp / 100)).toFixed(1));
    var rows = qa('[data-dq-lstep]', sec);
    var per = 100 / Math.max(rows.length, 1);
    rows.forEach(function (r, k) {
      var done = lp >= per * (k + 1) - 0.001, active = !done && lp >= per * k;
      r.classList.toggle('is-done', done);
      r.classList.toggle('is-active', active);
    });
  }

  function startLoading() {
    var sec = screenEl('loading');
    if (!sec) return showResult();
    show('loading');
    var secs = parseFloat(sec.getAttribute('data-seconds'));
    var dur = Math.max(1, isNaN(secs) ? 4.5 : secs) * 1000;
    var t0 = Date.now();
    clearTimers();
    paintLoading(0);
    state.timer = setInterval(function () {
      var lp = Math.min(100, (Date.now() - t0) / dur * 100);
      paintLoading(lp);
      if (lp >= 100) {
        clearInterval(state.timer);
        state.delay = setTimeout(showResult, 500);
      }
    }, 50);
  }

  /* ---------- results ---------- */
  function score() {
    return state.answers.reduce(function (sum, a) { return sum + (a ? a.points : 0); }, 0);
  }

  function pickTier(total) {
    var tiers = qa('[data-dq-tier]');
    if (!tiers.length) return null;
    var sorted = tiers.slice().sort(function (a, b) { return parseFloat(b.getAttribute('data-min')) - parseFloat(a.getAttribute('data-min')); });
    for (var i = 0; i < sorted.length; i++) {
      var min = parseFloat(sorted[i].getAttribute('data-min'));
      if (total >= (isNaN(min) ? 0 : min)) return sorted[i];
    }
    return sorted[sorted.length - 1];
  }

  function applyTier(tierEl) {
    qa('[data-dq-tier]').forEach(function (t) { t.hidden = t !== tierEl; });
    var sec = screenEl('result'); if (!sec) return;
    var key = tierEl ? tierEl.getAttribute('data-dq-tier') : '';
    state.tier = key;
    var buy = q('[data-dq-buy]', sec);
    if (buy) {
      var url = sec.getAttribute('data-url') || '';
      if (url) {
        var extra = [];
        var utm = (sec.getAttribute('data-utm') || '').replace(/^[?&]+/, '');
        if (utm) extra.push(utm);
        if (sec.getAttribute('data-append-fit') === 'true' && key) extra.push('fit=' + encodeURIComponent(key));
        if (extra.length) {
          var hashIdx = url.indexOf('#');
          var hash = hashIdx > -1 ? url.slice(hashIdx) : '';
          var base = hashIdx > -1 ? url.slice(0, hashIdx) : url;
          url = base + (base.indexOf('?') > -1 ? '&' : '?') + extra.join('&') + hash;
        }
        buy.setAttribute('href', url);
      }
    }
  }

  function showResult() {
    clearTimers();
    state.score = score();
    var tierEl = pickTier(state.score);
    applyTier(tierEl);
    show('result');
    if (tierEl && !designMode) { var h = q('.fc-res-h1', tierEl); if (h) h.focus({ preventScroll: true }); }
    track('quiz_complete', { score: state.score, tier: state.tier, answers: JSON.stringify(state.answers.map(function (a) { return a && { id: a.id, answer: a.label, points: a.points }; })) });
  }

  function restart() { clearTimers(); state.i = 0; state.answers = []; show(screenEl('intro') ? 'intro' : 'quiz'); if (!screenEl('intro')) renderQuestion(); }

  /* ---------- events (delegated, so they survive editor reloads) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentNode;
    var el;
    if ((el = t.closest('[data-dq-start]'))) { e.preventDefault(); start(); return; }
    if ((el = t.closest('[data-dq-opt]'))) { pick(parseInt(el.getAttribute('data-dq-opt'), 10), el); return; }
    if ((el = t.closest('[data-dq-back]'))) {
      clearTimeout(state.delay);
      if (state.i > 0) { state.i--; renderQuestion(true); } else show(screenEl('intro') ? 'intro' : 'quiz');
      return;
    }
    if ((el = t.closest('[data-dq-restart]'))) { restart(); return; }
    if ((el = t.closest('[data-dq-buy]'))) {
      if (designMode) { e.preventDefault(); return; }
      track('quiz_cta_click', { tier: state.tier, score: state.score, url: el.href });
    }
  });

  function pauseVesselIfReduced() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      qa('[data-dq-vessel] svg').forEach(function (svg) { if (svg.pauseAnimations) svg.pauseAnimations(); });
    }
  }

  /* ---------- theme editor ---------- */
  function previewScreen(name, sectionEl, blockEl) {
    clearTimers();
    if (name === 'quiz') {
      if (blockEl && blockEl.hasAttribute('data-dq-qblock')) state.i = parseInt(blockEl.getAttribute('data-dq-qblock'), 10) || 0;
      show('quiz', { keepScroll: true }); renderQuestion(false);
    } else if (name === 'loading') {
      show('loading', { keepScroll: true }); paintLoading(62);
    } else if (name === 'result') {
      var tier = blockEl && blockEl.closest('[data-dq-tier]');
      applyTier(tier || qa('[data-dq-tier]')[0] || null);
      show('result', { keepScroll: true });
    } else {
      show('intro', { keepScroll: true });
    }
  }
  function nameFor(el) {
    if (!el) return null;
    if (el.querySelector('[data-dq-footer]') || (el.matches && el.matches('[data-dq-footer]'))) return 'intro';
    var s = el.matches && el.matches('[data-dq-screen]') ? el : el.querySelector('[data-dq-screen]');
    return s ? s.getAttribute('data-dq-screen') : null;
  }
  if (designMode) {
    document.addEventListener('shopify:section:select', function (e) { var n = nameFor(e.target); if (n) previewScreen(n, e.target); });
    document.addEventListener('shopify:section:load', function (e) {
      pauseVesselIfReduced();
      var n = nameFor(e.target);
      previewScreen(n && n !== 'intro' ? n : state.screen, e.target);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var sec = e.target.closest('.shopify-section') || e.target;
      var n = nameFor(sec); if (n) previewScreen(n, sec, e.target);
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    pauseVesselIfReduced();
    show(screenEl('intro') ? 'intro' : 'quiz', { keepScroll: true });
    if (!screenEl('intro')) renderQuestion();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  window.DQQuiz = { start: start, show: show, score: score, state: state };
})();
